import { AppUpdatesListPage } from '@app/app-updates';
import { AppUpdatesDetailsPage } from '../../app-details';

export const appUpdatesListRoute = {
  name: 'app-updates',
  path: '/release-notes',
  exact: true,
  component: AppUpdatesListPage,
  resources: [],
};

export const appUpdatesDetailsRoute = {
  name: 'app-updates-details',
  path: '/release-notes/:id',
  exact: true,
  component: AppUpdatesDetailsPage,
  resources: [],
};
